import { render } from "./when.vue?vue&type=template&id=9c46b836"
import script from "./when.vue?vue&type=script&lang=js"
export * from "./when.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__